(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["artisan-faq"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.faq-question').forEach(question => {
    question.addEventListener('click', () => {
      const answer = question.nextElementSibling;
      const icon = question.querySelector('.faq-icon');
      const isActive = answer.classList.contains('show');
      
      // Close all other FAQs
      document.querySelectorAll('.faq-answer').forEach(ans => {
        ans.classList.remove('show');
      });
      document.querySelectorAll('.faq-question').forEach(q => {
        q.classList.remove('active');
      });
      document.querySelectorAll('.faq-icon').forEach(ic => {
        ic.classList.remove('rotate');
        ic.textContent = '+';
      });
      
      // Toggle current FAQ
      if (!isActive) {
        answer.classList.add('show');
        question.classList.add('active');
        icon.classList.add('rotate');
        icon.textContent = '+';
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["artisan-testimonials"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const wrapper = document.querySelector('.artisan-testimonial-wrapper');
  const testimonials = document.querySelectorAll('.artisan-testimonial');
  const prevBtn = document.querySelector('.artisan-testimonial-prev');
  const nextBtn = document.querySelector('.artisan-testimonial-next');
  const section = document.querySelector('.artisan-testimonials');
  const navigation = document.querySelector('.artisan-testimonial-navigation');
  
  let currentIndex = 0;
  let autoScrollInterval;
  let shouldSlide = false;
  let isTransitioning = false;
  let originalTestimonialCount = testimonials.length;

  function cloneTestimonialsForInfiniteScroll() {
    // Clone first few testimonials and append to end
    for (let i = 0; i < Math.min(3, originalTestimonialCount); i++) {
      const clone = testimonials[i].cloneNode(true);
      clone.classList.add('cloned');
      wrapper.appendChild(clone);
    }
    
    // Clone last few testimonials and prepend to beginning
    for (let i = Math.max(0, originalTestimonialCount - 3); i < originalTestimonialCount; i++) {
      const clone = testimonials[i].cloneNode(true);
      clone.classList.add('cloned');
      wrapper.insertBefore(clone, wrapper.firstChild);
    }
    
    // Update current index to account for prepended clones
    currentIndex = Math.min(3, originalTestimonialCount);
  }

  function calculateVisibleTestimonials() {
    const container = section.querySelector('.artisan-testimonials-container');
    const containerWidth = container.offsetWidth - 40; // Account for padding
    
    if (testimonials.length === 0) return 1;
    
    // Get the minimum card width from CSS custom properties or data attributes
    const computedStyle = getComputedStyle(section);
    const minCardWidth = parseInt(computedStyle.getPropertyValue('--min-card-width')) || 325;
    const gap = parseInt(computedStyle.getPropertyValue('--grid-gap')) || 30;
    
    // Calculate how many complete cards can fit
    let visibleCount = 1;
    let totalWidth = minCardWidth;
    
    while (totalWidth + gap + minCardWidth <= containerWidth && visibleCount < originalTestimonialCount) {
      visibleCount++;
      totalWidth += gap + minCardWidth;
    }
    
    return visibleCount;
  }

  function updateCardWidth() {
    if (!shouldSlide) return;
    
    const visibleCount = calculateVisibleTestimonials();
    const container = section.querySelector('.artisan-testimonials-container');
    const containerWidth = container.offsetWidth - 40;
    const computedStyle = getComputedStyle(section);
    const gap = parseInt(computedStyle.getPropertyValue('--grid-gap')) || 30;
    const allTestimonials = wrapper.querySelectorAll('.artisan-testimonial');
    
    // Calculate exact width for each card to fit perfectly
    const totalGap = (visibleCount - 1) * gap;
    const cardWidth = (containerWidth - totalGap) / visibleCount;
    
    // Apply the calculated width to all testimonials
    allTestimonials.forEach(testimonial => {
      testimonial.style.flex = `0 0 ${cardWidth}px`;
      testimonial.style.width = `${cardWidth}px`;
      testimonial.style.minWidth = `${cardWidth}px`;
      testimonial.style.maxWidth = `${cardWidth}px`;
    });
    
    // Update wrapper to show exact number of visible cards
    wrapper.style.width = `${visibleCount * cardWidth + (visibleCount - 1) * gap}px`;
  }

  function checkIfSlidingNeeded() {
    const visibleCount = calculateVisibleTestimonials();
    const totalCount = originalTestimonialCount;
    
    shouldSlide = totalCount > visibleCount;
    
    if (shouldSlide) {
      section.classList.add('sliding');
      navigation.classList.add('show');
      cloneTestimonialsForInfiniteScroll();
      updateCardWidth(); // Ensure cards fit perfectly
      updateTransform(false); // Set initial position without transition
      startAutoScroll();
    } else {
      section.classList.remove('sliding');
      navigation.classList.remove('show');
      stopAutoScroll();
      wrapper.style.transform = 'translateX(0)';
      // Remove cloned elements
      wrapper.querySelectorAll('.cloned').forEach(clone => clone.remove());
      // Reset card widths for static grid
      const allTestimonials = wrapper.querySelectorAll('.artisan-testimonial');
      allTestimonials.forEach(testimonial => {
        testimonial.style.flex = '';
        testimonial.style.width = '';
      });
    }
  }

  function updateTransform(withTransition = true) {
    if (!shouldSlide) return;
    
    const allTestimonials = wrapper.querySelectorAll('.artisan-testimonial');
    if (allTestimonials.length === 0) return;
    
    const cardWidth = allTestimonials[0].offsetWidth + parseInt(getComputedStyle(allTestimonials[0]).marginRight || '0');
    
    if (withTransition) {
      wrapper.style.transition = 'transform 0.5s ease';
    } else {
      wrapper.style.transition = 'none';
    }
    
    wrapper.style.transform = `translateX(-${currentIndex * cardWidth}px)`;
  }
  
  function handleInfiniteScroll() {
    const allTestimonials = wrapper.querySelectorAll('.artisan-testimonial');
    const totalWithClones = allTestimonials.length;
    const cloneBuffer = Math.min(3, originalTestimonialCount);
    
    // If we've reached the end (including buffer), reset to beginning
    if (currentIndex >= totalWithClones - cloneBuffer) {
      setTimeout(() => {
        isTransitioning = true;
        currentIndex = cloneBuffer;
        updateTransform(false);
        setTimeout(() => {
          isTransitioning = false;
        }, 50);
      }, 500); // Wait for current transition to complete
    }
    
    // If we've gone before the beginning, reset to end
    if (currentIndex < cloneBuffer) {
      setTimeout(() => {
        isTransitioning = true;
        currentIndex = totalWithClones - cloneBuffer - 1;
        updateTransform(false);
        setTimeout(() => {
          isTransitioning = false;
        }, 50);
      }, 500);
    }
  }
  
  function autoScroll() {
    if (!shouldSlide || isTransitioning) return;
    
    currentIndex++;
    updateTransform(true);
    handleInfiniteScroll();
  }

  function startAutoScroll() {
    stopAutoScroll();
    autoScrollInterval = setInterval(autoScroll, 5000);
  }

  function stopAutoScroll() {
    if (autoScrollInterval) {
      clearInterval(autoScrollInterval);
      autoScrollInterval = null;
    }
  }
  
  nextBtn.addEventListener('click', () => {
    if (!shouldSlide || isTransitioning) return;
    
    currentIndex++;
    updateTransform(true);
    handleInfiniteScroll();
    startAutoScroll();
  });
  
  prevBtn.addEventListener('click', () => {
    if (!shouldSlide || isTransitioning) return;
    
    currentIndex--;
    updateTransform(true);
    handleInfiniteScroll();
    startAutoScroll();
  });
  
  function updateNavPosition() {
    const nav = document.querySelector('.artisan-testimonial-navigation');
    const grid = section.querySelector('.artisan-testimonial-grid');
    if (!nav || !grid) return;
    
    const gridRect = grid.getBoundingClientRect();
    const sectionRect = section.getBoundingClientRect();
    
    const relativeTop = (gridRect.top - sectionRect.top) + (gridRect.height / 2);
    nav.style.top = relativeTop + 'px';
  }
  
  function handleResize() {
    // Clean up existing clones
    wrapper.querySelectorAll('.cloned').forEach(clone => clone.remove());
    currentIndex = 0;
    
    checkIfSlidingNeeded();
    updateNavPosition();
    
    // Recalculate card widths if sliding is enabled
    if (shouldSlide) {
      updateCardWidth();
    }
  }
  
  // Initial setup
  handleResize();
  
  // Handle window resize
  window.addEventListener('resize', handleResize);
  
  // Pause auto-scroll on hover
  section.addEventListener('mouseenter', stopAutoScroll);
  section.addEventListener('mouseleave', () => {
    if (shouldSlide) startAutoScroll();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
